module.exports = __webpack_public_path__ + "static/media/drum-steelpan.fa3a9d2f.svg";